import { Widget } from "fmko-ts-common";

export default class UseTestGroupWidget extends Widget {
    constructor(name: string, selectedGroups: Array<string>) {
        super();

        let checkbox = <HTMLInputElement>document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "checkbox-inline";
        checkbox.checked = false;

        checkbox.addEventListener("click", (ev: MouseEvent) => {
            if (checkbox.checked) {
                if (selectedGroups.indexOf(name) === -1) {
                    selectedGroups.push(name);
                }
            } else {
                if (selectedGroups.indexOf(name) > -1) {
                    selectedGroups.splice(selectedGroups.indexOf(name), 1);
                }
            }
        });

        checkbox.addEventListener("load", ev => {
            if (checkbox.checked) {
                if (selectedGroups.indexOf(name) === -1) {
                    selectedGroups.push(name);
                }
            } else {
                if (selectedGroups.indexOf(name) > -1) {
                    selectedGroups.splice(selectedGroups.indexOf(name), 1);
                }
            }
        });
        this.element = checkbox;
    }
}
